import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function TradeExposure({ tradeExposure = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "key_countries", label: "Key Countries" },
        { key: "exposure_pct", label: "Exposure (%)" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "key_countries", label: "Key Countries" },
        { key: "exposure_pct", label: "Exposure (%)" },
        { key: "tariff_risk", label: "Tariff Risk" },
        { key: "supply_chain_dependency", label: "Supply Chain Dependency" },
        { key: "mitigation_strategy", label: "Mitigation Strategy" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    // console.log("TRADE: " + JSON.stringify(tradeExposure));
    const transformed = transformResultsToCompProfileData(tradeExposure);
    setTabData(transformed);

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={tradeExposure?.[0]?.response?.tableComments || ""}
      />
    );
  }, [tradeExposure]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Trade Exposure"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="key_countries"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default TradeExposure;
